import { render, staticRenderFns } from "./DebugButton.vue?vue&type=template&id=4184fb42"
import script from "./DebugButton.vue?vue&type=script&lang=js"
export * from "./DebugButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports